import { Typography } from '@rbilabs/universal-components';
import { differenceInDays } from 'date-fns';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

interface IQuestEndDateMessage {
  endDate: string;
}

const DAYS_LEFT_WITHIN_SEVEN_DAYS = 7;

export const QuestEndDateMessage = ({ endDate }: IQuestEndDateMessage) => {
  const challengeEndDate = new Date(endDate);
  const daysLeft = differenceInDays(challengeEndDate, new Date());

  const message =
    daysLeft > 0 && daysLeft <= DAYS_LEFT_WITHIN_SEVEN_DAYS
      ? t('challengeEndsInLabel', { days: daysLeft })
      : null;

  return message ? (
    <Typography variant="copyTwo" style={{ color: primitive.$bbqRed }}>
      {message}
    </Typography>
  ) : null;
};
